import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=6d0217c4"
var script = {}
import style0 from "./auth.vue?vue&type=style&index=0&id=6d0217c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports